import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// import { initSmoothScroll } from './modules/smoothScroll';

// import { dragscroll } from './modules/dragscroll';
// dragscroll();

import { accordion } from './modules/accordion';

// import { service } from './modules/service';

gsap.registerPlugin(ScrollTrigger);

// const lenis = initSmoothScroll();
// window.lenis = lenis;

window.addEventListener("load", () => {
	accordion();

	const header = document.querySelector('.j-header');
	const mv = document.querySelector('.p-mv');

	if (!header || !mv) return;

	let isFixed = false;

	const observer = new IntersectionObserver(
		([entry]) => {
		// MVが画面内
		if (entry.isIntersecting) {
			isFixed = false;
			header.classList.remove('is-fixed');
			return;
		}

		// MVが画面上部へ抜けた
		if (entry.boundingClientRect.bottom <= 0 && !isFixed) {
			isFixed = true;
			header.classList.add('is-fixed');
		}
		},
		{
		threshold: 0,
		}
	);

	observer.observe(mv);

});